import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching Enabled Flag values failed' }))
  .then(parseAsJson);

export const generateR2RChart = async periodName => await fetch(
  Config.endpoints.GENERATE_R2R_CHART_TLS_ACCOUNTS.replace(':periodName', periodName),
  {
    method: 'GET',
  }
)
  .then(handleErrors({ errorMessage: 'Generating R2R api failed' }));

export const fetchCategoriesWithTags = async periodName => await fetch(
  Config.endpoints.FETCH_CATEGORIES_WITH_TAGS_LIST
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Categories with Tags failed' }))
  .then(parseAsJson);

export const fetchTags = async periodName => await fetch(
  Config.endpoints.FETCH_TAGS
    .replace(/:periodName/, periodName)

)
  .then(handleErrors({ errorMessage: 'Fetching Tags failed' }))
  .then(parseAsJson);

export const fetchTLSAccounts = async periodName => await fetch(
  Config.endpoints.FETCH_TLS_ACCOUNTS
    .replace(/:periodName/, periodName)

)
  .then(handleErrors({ errorMessage: 'Fetching Tags failed' }))
  .then(parseAsJson);
